module.exports = "../../../../platform/assets/pageMainIcon/icon-zhuangtai-2-yellow.svg";